import { TranslateObjectFunction, useI18N } from '@tm/client-form/src/hooks/useI18n'
import { Field } from '@tm/shared-lib/src/field'
import { useMemo } from 'react'
import { ViewProps } from '../types'
import { ReviewFields } from './useReviewFields'

const getTranslatedValues = (field: Field | undefined, tt: TranslateObjectFunction) => {
  const values = {
    label: '',
    description: '',
    inputLabel: '',
  }

  if (!field || field.type !== 'video') return values

  const { label, description } = field

  values.label = tt(label)
  values.description = tt(description)

  return values
}

export function useVideoReview(props: ViewProps, reviewFields: ReviewFields) {
  const { state, validationErrors } = props
  const { t, tt } = useI18N()

  const videoField = reviewFields.get('comment_video')

  const videoError = useMemo(() => {
    if (validationErrors.comment_video) {
      return validationErrors.comment_video.map(error => t(error)).join(', ')
    }
    return ''
  }, [validationErrors, t])

  const videoValue = state.values.comment_video || state.files.comment_video

  const { label, description } = getTranslatedValues(videoField, tt)

  return {
    hasVideoReview: !!videoField,
    videoValue,
    videoError,
    label,
    description,
    videoField,
    demo: false,
  }
}

export type UseVideoReview = ReturnType<typeof useVideoReview>
